import PropTypes from 'prop-types';
import { DraggableModalDialog } from '../DraggableModalDialog';
import { Button, Modal } from 'react-bootstrap';
function SupportDlg(props) {

    SupportDlg.propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func.isRequired
    }

    return (
        <Modal dialogAs={DraggableModalDialog} show={props.isOpen} onHide={props.toggleModal} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    Cert App Support
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <strong>Primary support is provided by:</strong>
                </p>
                <p>Quality Management Team (QM)</p>
                <p>1) Raise your request or incidents at: <a href="https://goto/qmt" target="_blank" rel="noopener noreferrer">https://goto/qmt</a></p>
                <p>2) To escalate your request or incident please email: <a href="mailto:GSC-EMIT-QM-MSP@exxonmobil.com">GSC-EMIT-QM-MSP@exxonmobil.com</a></p>
            </Modal.Body>
            <Modal.Footer>
                <Button color="primary" onClick={props.toggleModal}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SupportDlg;